import { Link } from "react-router-dom";
import Logo from "./../images/logo.png";

const Footer = () => {
  return (
    <div className="bg-sky pt-5 pb-2">
      <div className="container">
        <div className="fotter">
          <div className="logo_img text-center">
            <Link to="#">
              <img src={Logo} alt="logo" />
            </Link>
          </div>
          <div className="social text-center mt-3 mb-3">
            <Link to="#" className="mx-2 text-light">
              <i className="fa fa-facebook" />
            </Link>
            <Link to="#" className="mx-2 text-light">
              <i className="fa fa-twitter" />
            </Link>
            <Link to="#" className="mx-2 text-light">
              <i className="fa fa-instagram" />
            </Link>
          </div>
          <div className="copy text-center mt-3 mb-3">
            <p className="text-light">
              Copyright 2023 logo all right Reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
